import React from 'react';
import useScrollReveal from '../hooks/useScrollReveal';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();
  const revealRef = useScrollReveal();

  return (
    <footer className="footer reveal" id="contact" ref={revealRef}>
      <div className="container">
        <div className="footer-content">
          <div className="footer-main">
            <span className="section-label">{"// Let's Connect"}</span>
            <h2 className="footer-title">
              Got a project, a question,<br />
              or just want to talk football?
            </h2>
            <p className="footer-text">
              I'm always open to new opportunities, collaborations, or a good
              conversation. Whether it's about code, coaching, or the best
              afrobeats playlist — hit me up.
            </p>

            <div className="footer-actions">
              <a href="mailto:okaforobinna547@gmail.com" className="btn btn-primary">
                Send Me an Email
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M7 17L17 7M17 7H7M17 7V17"/>
                </svg>
              </a>
              <a href="/Stanley_Okafor_Resume.pdf" className="btn btn-secondary" target="_blank" rel="noopener noreferrer">
                View Resume
              </a>
            </div>
          </div>

          <div className="footer-links">
            <div className="link-group">
              <h3 className="link-title">Connect</h3>
              <a href="mailto:okaforobinna547@gmail.com" className="footer-link">
                Email
              </a>
              <a href="https://www.linkedin.com/in/stanley-okafor-aura1/" className="footer-link" target="_blank" rel="noopener noreferrer">
                LinkedIn
              </a>
              <a href="https://github.com/Stanleyashz" className="footer-link" target="_blank" rel="noopener noreferrer">
                GitHub
              </a>
              <a href="https://x.com/Stanley36114847" className="footer-link" target="_blank" rel="noopener noreferrer">
                Twitter
              </a>
            </div>

            <div className="link-group">
              <h3 className="link-title">Location</h3>
              <p className="footer-location">Mississauga, Ontario</p>
              <p className="footer-location">George Brown College</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="copyright mono">
            &copy; {currentYear} Stanley Okafor. Built with React & good vibes.
          </p>
          <p className="version mono">v2.0</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
